import React, { useState } from "react";
import MobileDrawer from "../../layout/MobileDrawer";
import { Link } from "react-router-dom";
import {
  ChevronDownMicro,
  ChevronUpMicro,
  Drawerbar,
  SearchOutine,
  UserOutline,
} from "../../assets/SvgIcons";
import { dummyNavLinks } from "../../assets/DummyData";
import {
  dark_hero_bg_svg,
  icon,
  light_logo,
  light_logo2,
  light_logo3,
} from "../../assets";
import { useSelector } from "react-redux";

const Navbar = ({ maxWidth = 1200 }) => {
  const auth = useSelector((state) => state.auth);

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const isAuthorized = auth.authenticate;
  return (
    <nav className="w-full bg-primary">
      {/* Drawer for Mobile Navigation */}
      <MobileDrawer
        isDrawerOpen={isDrawerOpen}
        setIsDrawerOpen={setIsDrawerOpen}
      />

      {/* Top Bar for Announcement or Promotion */}
      {/* <TopBar /> */}

      {/* Primary Navigation Section with Logo, Search, and Login/Register */}
      <PrimaryNavigation
        isDrawerOpen={isDrawerOpen}
        setIsDrawerOpen={setIsDrawerOpen}
        isAuthorized={isAuthorized}
        maxWidth={maxWidth}
      />

      {/* Secondary Navigation Section with Links */}
      <SecondaryNavigation
        isAuthorized={isAuthorized}
        maxWidth={maxWidth}
        marginTop={-20}
      />
    </nav>
  );
};

export default Navbar;

// TopBar Component: Displays a promotional or informational message at the top
const TopBar = () => {
  return (
    <header className=" bg-secondary p-2 text-white text-[12px] text-center">
      {/* Promotional message */}
      Have you tried the WristLink app? Discover now!
    </header>
  );
};

// PrimaryNavigation Component: Contains the logo, search bar, and login/register buttons
const PrimaryNavigation = ({
  setIsDrawerOpen,
  isDrawerOpen,
  isAuthorized,
  maxWidth,
}) => {
  const dealer = JSON.parse(localStorage.getItem("dealer"));

  return (
    <div className="mx-auto px-4" style={{ maxWidth: maxWidth }}>
      <div className="flex items-center justify-between">
        {/* Drawer Toggle */}

        <button
          onClick={() => setIsDrawerOpen(!isDrawerOpen)}
          className="lg:hidden md:hidden sm:block"
        >
          {Drawerbar}
        </button>

        {/* Logo */}
        <Link to={"/"} className="flex gap-2 items-center">
          <img
            className="lg:block md:block sm:hidden"
            src={icon}
            height={125}
            width={125}
            alt=""
          />
          <img
            className="lg:hidden md:hidden sm:block"
            src={icon}
            height={80}
            width={80}
            alt=""
          />

          {/* <div
            style={{
              backgroundImage: `url(${light_logo2})`,

              backgroundPosition: "center",
              backgroundSize: "cover",
              height: 100,
              width: 100,
            }}
            // className="h-[50px] w-[50px]"
          ></div> */}
          {/* <div className="text-xl font-bold lg:block md:block sm:hidden">
            WristLink
          </div> */}
        </Link>

        {/* Search Bar Large, Medium */}
        {/* {isAuthorized && ( */}
        <div className="lg:block md:block sm:hidden w-1/2 ">
          <SearchBar marginTop={-12} />
        </div>
        {/* )} */}
        {/* Login/Register Button */}
        {isAuthorized ? (
          <Link
            to={"/user"}
            className="flex gap-1  items-center max-w-[125px] lg:mt-[-12px] md:mt-[-12px] sm:mt-[0px]"
          >
            <div
              style={{
                backgroundImage: `url(${dealer?.avatar})`,

                backgroundPosition: "center",
                backgroundSize: "cover",
              }}
              className="lg:h-[44px] lg:w-[44px] md:h-[36px] md:w-[36px] sm:h-[36px] sm:w-[36px]  bg-white rounded-full border-2 border-gray-400"
            />
            <div className="lg:block md:block sm:hidden text-[#292929]">
              <p className="text-[12px] font-bold ">
                {dealer.companyTitle?.slice(0, 10)}..
              </p>
              <p className="text-[11px] font-semibold">View profile</p>
            </div>
            {/* <span className="lg:block md:block sm:hidden text-[12px] font-bold text-[#292929]">
              {dealer.companyTitle}
            </span> */}
          </Link>
        ) : (
          <Link to={"/auth/login"} className="flex gap-1">
            {UserOutline}{" "}
            <span className="lg:block md:block sm:hidden">
              Log in or Register
            </span>
          </Link>
        )}
      </div>

      {/* Search Bar For Small */}
      {/* {isAuthorized && ( */}
      <div className="lg:hidden md:hidden sm:block w-full mt-0 pb-6">
        <SearchBar />
      </div>
      {/* )} */}
    </div>
  );
};

const SearchBar = ({ marginTop }) => {
  return (
    <div
      style={{ marginTop: marginTop }}
      className="p-2  rounded bg-[#F3F3F3] flex items-center w-full"
    >
      {SearchOutine}
      <input
        type="text"
        placeholder="Search through thousands of watches worldwide"
        className="pl-1 bg-[#F3F3F3] w-full outline-none lg:text-[15px] md:text-[14px] sm:text-[13px]"
      />
    </div>
  );
};

const SecondaryNavigation = ({ isAuthorized, maxWidth, marginTop }) => {
  const [subcatOpen, setSubCat] = useState(-1);
  let lenSubCat = dummyNavLinks[subcatOpen]?.subcategories?.length;
  return (
    <div className={"lg:block md:block sm:hidden"}>
      <div
        className=" flex gap-12 justify-center items-center p-1 mx-auto "
        style={{ maxWidth: maxWidth, marginTop: marginTop }}
      >
        {dummyNavLinks?.map((navlink, index) => {
          if (navlink.url && !navlink.subcategories) {
            return (
              <Link
                key={index}
                to={navlink?.url}
                className={`lg:text-[16px] md:text-[12px]`}
                // className={`border-b-2 lg:text-[16px] md:text-[12px]${
                //   index === subcatOpen
                //     ? "border-b-primary font-bold"
                //     : "border-b-[#292929]"
                // }`}
                onClick={() => setSubCat(index)}
              >
                {navlink?.title}
              </Link>
            );
          } else
            return (
              <button
                key={index}
                onClick={() =>
                  index === subcatOpen ? setSubCat(-1) : setSubCat(index)
                }
                className={`flex gap-1 items-center lg:text-[16px] md:text-[12px]   `}
                // className={`flex gap-1 items-center border-b-2 lg:text-[16px] md:text-[12px]  ${
                //   index === subcatOpen
                //     ? "border-b-primary font-bold"
                //     : "border-b-[#292929]"
                // } `}
              >
                {navlink?.title}{" "}
                {index === subcatOpen ? ChevronUpMicro : ChevronDownMicro}
              </button>
            );
        })}
      </div>

      <div className="w-full ">
        <div
          className={` transition-all text-[14px] duration-500 ease-in-out overflow-hidden ${
            subcatOpen !== -1 ? "max-h-[800px] px-4 pt-4" : "max-h-0 p-0"
          }`}
        >
          <div
            className={`  transition-opacity duration-300 border-b ${
              subcatOpen !== -1 ? "opacity-100" : "opacity-0"
            }`}
          >
            {/* PREVIOUSLY MAX_W_1200 */}
            <div className={`max-w-[606px] mx-auto flex justify-between `}>
              {dummyNavLinks[subcatOpen]?.subcategories?.map(
                (subcat, index1) => {
                  return (
                    <div
                      className={`flex flex-col p-2  ${
                        lenSubCat === 1
                          ? "w-full"
                          : lenSubCat === 2
                          ? "w-1/2"
                          : lenSubCat === 3
                          ? "w-1/3"
                          : lenSubCat === 4
                          ? "w-1/4"
                          : lenSubCat === 5
                          ? "w-1/5"
                          : lenSubCat === 6
                          ? "w-1/6"
                          : "w-1/3"
                      }`}
                    >
                      <strong key={index1} className="text-[16px] mb-2">
                        {subcat?.name}
                      </strong>

                      {subcat?.image && (
                        <img
                          src={subcat?.image}
                          alt={subcat?.description}
                          className="mb-2 rounded"
                        />
                      )}
                      {subcat?.description && (
                        <span className="mb-2">{subcat?.description}</span>
                      )}

                      {subcat?.links?.map((links, index2) => {
                        return (
                          <Link
                            key={index2}
                            to={links?.url}
                            // to={`/explore-brands?name=${links?.label}`}
                            onClick={() => {
                              setSubCat(-1);
                            }}
                            className={`mb-2  ${
                              subcat?.description && "underline"
                            }`}
                          >
                            {links?.label}
                          </Link>
                        );
                      })}
                    </div>
                  );
                }
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
